@use "../../../../styles/variables" as *;
@use "../../../../styles/mixins" as *;

// google zoom-control
.gm-style .gmnoprint.gm-bundled-control .gmnoprint {
  @include desktop {
    left: -20px !important;
  }
}

// google navigation-control
.gm-bundled-control {
  bottom: 100px !important;
}

// back-arrow
.back-arrow {
  position: absolute;
  border: none;
  background: none;
  margin: 0;
  padding: 0;
  z-index: 2;
  top: 2rem;
  left: 2rem;
}

// section-divider
.section-divider {
  padding: 8px 15px;
  font-size: 12px;
  font-weight: 500;
  color: #666;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.google-places-section,
.ny-stores-section {
  margin: 0;
  text-transform: capitalize;
}

// marker-content
.marker-container {
  position: relative;
  justify-content: center;
  display: flex;
  align-items: center;

  &.bounce {
    animation: bounce 0.8s ease;
  }
}

// cluster count
.count-text {
  position: absolute;
  color: white;
  font-weight: bold;
}

// gps location
.pulsing-circle {
  position: absolute;
  width: 2rem;
  height: 2rem;
  background-color: rgba(0, 122, 255, 0.3);
  border-radius: 50%;
  animation: pulse 2.5s infinite ease-out;
  z-index: 1;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.6;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

// login-dialog
.login-dialog {
  display: none;

  &.not-logged {
    display: block;
  }
}

// backdrop
.overlay {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1;
  display: none;

  @include mobile {
    opacity: 0;
    transition: all .3s ease-in;
  }

  &.active {
    z-index: 2;
    opacity: 1;
    transition: all .3s ease-in;
    display: block;
  }
}

// main
.store-locator {
  letter-spacing: .2px;
  font-family: 'Roboto', Arial, sans-serif;
  overflow-y: hidden;
  height: calc(100dvh - 4rem);
  position: relative;
  -ms-overflow-style: none;
  scrollbar-width: none;
  line-height: 1.2;
  color: #363636;
}

.map {
  width: 100%;
  z-index: 0;
  opacity: 1;
  backface-visibility: hidden;
  height: 100%;
  transition: height 0.5s ease-in-out, opacity 0.5s ease-in-out;
  will-change: height, opacity;

  @include desktop {
    height: 100%;
    transition: none;
    will-change: auto;
  }

  &.showing-info {
    height: 50%;
    transition-delay: 0.3s;

    @include desktop {
      height: 100%;
      transition: none;
      transition-delay: 0s;
    }
  }

  &.showing-result {
    pointer-events: none;
    opacity: 0.7;

    @include desktop {
      pointer-events: auto;
      opacity: 1;
      height: 100%;
      transition: none;
    }
  }
}

.search-bar {
  position: absolute;
  display: flex;
  background-color: #f6f6f6;
  z-index: 2;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  left: 0;
  right: 0;
  margin: 1rem 1rem 0;

  @include desktop {
    position: absolute;
    margin: 0;
    border-radius: 10px;
    width: 25rem;
    top: 30px;
    left: 30px;
    transform: none;
  }

  &.hidden {
    z-index: 1;
  }

  .placeholder-container {
    position: absolute;
    display: flex;
    justify-content: left;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    z-index: 2;
    width: 94%;
    height: 100%;
    pointer-events: none;
    left: 8px;
    top: 1px;

    &.hidden {
      display: none;
      pointer-events: none;
    }

    @include desktop {
      width: 100%;
      left: 0;
      top: 0;
    }

    label {
      margin-left: 2rem;
      color: #5e5e5e;
      font-size: 16px;
      font-weight: 300;
      width: 100%;

      @include desktop {
        margin-left: 3rem;
        cursor: text;
        font-size: 1.1rem;
      }
    }
  }

  .icon {
    position: absolute;
    fill: $separator;
    z-index: 2;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;

    &.close {
      right: 0;
      top: 2px;

      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 35%;
        transform: translate(-50%, -50%);
        width: 30px;
        height: 30px;
        cursor: pointer;
      }

      @include desktop {
        top: 5px;

        &::after {
          width: 40px;
          height: 40px;
        }
      }
    }

    &.magnify {
      top: 2px;

      @include desktop {
        left: .5rem;
        top: 5px;
      }
    }
  }

  #input {
    box-sizing: border-box;
    border-radius: 5px;
    min-height: 44px;
    font-family: 'Roboto', Arial, sans-serif;
    font-size: 16px;
    font-weight: 300;
    padding: 0 .5rem;
    border: none;
    outline: 1.5px solid #d6d6d6;
    z-index: 1;
    padding-inline-start: 2.5rem;
    padding-inline-end: 2rem;
    width: 100%;

    @include desktop {
      margin: 0;
      width: 100%;
      background-color: $white;
      font-size: 1.1rem;
      height: 3rem;
      padding-inline-start: 3rem;
      padding-inline-end: 3rem;
    }
  }

  #input:focus {
    outline: 1px solid black;
  }

  .btn {
    border: none;
    background: none;
    margin: 0;
    padding: 0;
  }
}

.my-location-container {
  cursor: pointer;
  position: absolute;
  right: 10px !important;
  transform: translateY(-145px);

  @include desktop {
    right: 30px !important;
  }

  .background {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5%;
    width: 2.5rem;
    height: 2.5rem;
    background-color: $white;
    box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;

    @include desktop {
      &:hover {
        background-color: $grey-lighter;
      }
    }

    svg {
      width: 20px;
    }
  }
}

.content {
  border-radius: 10px 10px 0 0;
  overflow: hidden;
  width: 100%;
  position: absolute;
  z-index: 1;
  background-color: var(--white);
  bottom: 0;
  box-shadow: 0 -5px 15px $grey-late;
  will-change: transform;
  backface-visibility: hidden;
  height: 100svh;
  transform: translate3d(0, 100%, 0);
  transition: transform 0.5s ease-in-out;

  @include desktop {
    position: absolute;
    width: 25rem;
    top: 77px;
    left: 30px;
    bottom: auto;
    height: 0;
    transform: none;
    transition: none;
    will-change: height;
    animation: none;
    border-radius: 0 0 5px 5px;
    box-shadow: none;
  }

  &.showing-result {
    transform: translate3d(0, 22svh, 0);
    transition-delay: 0.3s;

    @include desktop {
      transform: none;
      height: fit-content;
      max-height: 50svh;
      overflow-y: scroll;
      scrollbar-width: none;
      -ms-overflow-style: none;
      box-shadow: 0 5px 15px $grey-late;
    }
  }

  &.showing-info {
    transform: translate3d(0, 47svh, 0);
    overflow-y: visible;
    transition-delay: 0.3s;

    @include desktop {
      transform: none;
      height: 34rem;
      box-shadow: 0 5px 15px $grey-late;
    }
  }
}

.result-list-container {
  max-height: 75svh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @include desktop {
    height: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.google-places-section {
  .google-result {
    display: block;
    align-items: center;
    padding: .5rem 1rem .5rem 1rem;
    cursor: pointer;
    box-sizing: border-box;
    min-height: 40px;

    @include desktop {
      margin: 0;

      &:hover {
        border-radius: 5px;
        background-color: $grey-lighter;
      }
    }

    p {
      margin: 0;

      font-size: .875rem;

      @include desktop {
        font-size: 1rem;
      }
    }
  }
}

.ny-stores-section {
  .ny-result {
    display: block;
    align-items: center;
    padding: .5rem 1rem .5rem 1rem;
    cursor: pointer;
    box-sizing: border-box;
    min-height: 40px;
    line-height: 1.1;

    @include desktop {
      margin: 0;

      &:hover {
        border-radius: 5px;
        background-color: $grey-lighter;
      }
    }

    .p1 {
      font-weight: 500;
      font-size: .875rem;

      @include desktop {
        font-size: 1rem;
      }
    }

    p {
      margin: .2rem 0 0 0;
      opacity: 0.9;

      font-size: .75rem;

      @include desktop {
        font-size: .875rem;
      }
    }

    .isFavourite {
      margin-right: .5rem;
      z-index: 1;
      position: relative;

      .background {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2rem;
        height: 2rem;
        border-radius: 100%;
        background-color: $ny-red;
        z-index: -1;

        svg {
          width: 18px;
          height: 18px;
        }
      }

      .heart {
        fill: $white;
      }
    }
  }
}

.info-box-container {
  background-color: #f6f6f6;
  padding: 1.5rem 1.5rem 7rem 1.5rem;
  height: 100%;
  overflow-y: auto;
  position: relative;
  -webkit-overflow-scrolling: touch;

  @include desktop {
    position: absolute;
    top: 0;
    width: 100%;
    border-radius: 0 0 10px 10px;
    box-shadow: 0 5px 15px $grey-late;
    overflow-y: visible;
    box-sizing: border-box;
    padding: 1.5rem 1.5rem 2rem 1.5rem;

    .close-icon {
      display: none;
      opacity: 0;
    }
  }

  .close-btn {
    width: 40px;
    height: 40px;
    cursor: pointer;
    right: 0.5rem;
    top: 0.5rem;
    position: absolute;
    border: none;
    background: none;
    padding: 0;
  }
}

.button-back {
  display: none;

  @include desktop {
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-right: .75rem;
    color: $grey;
    border: none;
    background: none;
    padding: 0;

    img {
      width: 16px;
      height: 18px;
    }

    p {
      font-size: .75rem;
      opacity: .7;
    }
  }
}

.store-address-wrapper {
  display: flex;

  button {
    align-items: flex-start;
  }

  .store-address {
    margin: 0;
    color: $grey-text;
    line-height: 1.1;

    @include desktop {
      margin: 0 .75rem 0 0;
      overflow-wrap: break-word;
    }

    .p1 {
      font-size: 1rem;
      font-weight: 500;
      margin-top: 0;
      text-transform: capitalize;

      @include desktop {
        font-size: 1.125rem;
      }
    }

    p {
      opacity: .9;
      margin: .2rem 0 0 0;
      font-size: .875rem;

      @include desktop {
        font-size: 1rem;
      }
    }
  }
}

.store-actions {
  padding: 1.5rem 0;
  display: flex;
  justify-content: center;
  align-items: center;

  @include desktop {
    margin: .5rem 0 1rem 0;
  }

  button {
    cursor: pointer;
  }

  .tile {
    background: $white-bis;
    border: 1px solid #888888;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 .8rem;
    border-radius: 5px;
    width: 4.5rem;
    height: 3rem;
    box-sizing: border-box;
    padding: 0;

    &:hover {
      background-color: $grey-lighter;
    }
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
      font-weight: 300;
      margin: .2rem;
    }
  }
}

.store-openings {
  text-align: left;

  @include desktop {
    height: auto;
    display: block;
  }

  .info-box-openings {

    @include desktop {
      margin-bottom: 1.5rem;
    }

    .openings-list {
      margin: 0;

      .openings {
        font-weight: 300;
        font-size: .875rem;
        margin: 0 0 3px 0;
        color: $grey;
        display: flex;
        align-items: center;
        justify-content: space-between;
        z-index: 100;

        @include desktop {
          font-size: 1rem;
        }

        &.current-day {
          font-weight: 700;
          color: $black;
        }

        .day {

          min-width: 5rem;
          margin: 0;
        }

        .time {
          margin: 0;
          display: flex;
          gap: 0.3rem;
        }
      }
    }

    .title {
      color: $grey-text;
      font-weight: 500;
      font-size: .75rem;
      margin-bottom: .5rem;

      @include desktop {
        font-size: 1rem;
      }
    }

    .opening-node {
      margin: 0 1rem;
      font-size: .75rem;
      font-style: italic;
      font-weight: 300;
      white-space: normal;
      display: flex;
    }
  }
}

.store-contact {
  padding-bottom: 1.5rem;

  @include desktop {
    padding-bottom: 0;
  }

  .title {
    font-size: .75rem;
    font-weight: 500;
    margin-bottom: .5rem;

    @include desktop {
      font-size: 1rem;
    }
  }

  .contact-line {
    font-weight: 300;
    font-size: .875rem;
    color: $grey;
    margin: 0;

    @include desktop {
      font-weight: 300;
      font-size: 1rem;
    }
  }
}

.modal-container {
  box-shadow: 0 5px 15px $grey-late;
  z-index: 3;
  background-color: #F5F5F5;
  position: fixed;
  width: 100%;
  top: 25%;
  left: 0;

  @include desktop {
    padding: 2.5rem 0;
  }

  @include tablet {
    top: 25%;
    right: 0;
    margin: auto;
    max-width: 25rem;
  }

  .close-btn {
    cursor: pointer;
    right: 10px;
    top: 10px;
    position: absolute;
    border: none;
    background: none;
    padding: 0;
  }

  .modal-content {
    .headline {
      margin: 2rem 2rem;
      text-align: center;
      color: $grey-text;
    }

    .input-container {
      display: grid;
      margin: 1rem 2rem 0 2rem;

      label {
        font-size: 1rem;
        font-weight: 400;
        color: $grey;
      }

      input {
        font-family: 'Roboto', Arial, sans-serif;
        font-weight: 300;
        padding-left: 0.5rem;
        height: 2.5rem;
        margin-bottom: 0.5rem;
        border-radius: 0;
        outline: none;
        border: 1px solid $separator;
        font-size: 16px;
      }

      input::placeholder {
        color: $input-grey;
      }

      input:focus {
        border: none;
        outline: 1px solid $black;
      }
    }

    .forgot-password-container {
      display: flex;
      justify-content: flex-end;
      margin-right: 2rem;
      font-size: 0.75rem;

      a {
        text-decoration: none;
        color: $grey-text-light;
        font-weight: 300;
        font-size: 13px;

        &:hover {
          color: $grey-text;
        }
      }
    }

    .button-container {
      margin: 1rem 2rem;
      display: flex;
      justify-content: center;

      .button {
        box-sizing: border-box;
        letter-spacing: 0.9px;
        height: 2.2rem;
        margin: 1rem 0;
        width: 8rem;
        cursor: pointer;
        border: 0;
        color: $grey-text;

        &.register {
          margin-right: .5rem;
          background-color: $register-white;
        }

        &.a {
          text-decoration: none;
          color: $grey-text;
          font-size: 0.875rem;
          line-height: 1;
        }

        &.login {
          margin-left: .5rem;
          border: none;
          color: $white;
          background-color: $red;

          &:disabled {
            background-color: $grey;
            cursor: default;

            &:hover {
              box-shadow: none;
            }
          }
        }
      }
    }
  }

  .flex-centered {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  // Wrong credentials
  .error-container {
    .err {
      color: $blue-info;
    }

    img {
      width: 1.8rem;
      height: 1.8rem;
    }
  }
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-15px);
  }
  40% {
    transform: translateY(0);
  }
  60% {
    transform: translateY(-10px);
  }
  80% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(0);
  }
}

.store-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: .25rem;

  > p {
    text-transform: none;
    margin: 0.2rem 0 0 0;
    font-size: 0.875rem;
    opacity: .9;
    font-weight: 300;
  }

  .separator {
    font-weight: 500;
    color: #999;
  }

  .status {
    &.open {
      color: $store-green;
    }

    &.opening, &.closing {
      color: $store-orange;
    }

    &.closed {
      color: $ny-red;
    }
  }
}